export default __webpack_public_path__ + "static/media/facebook.7cc27bc0.svg";